<script setup>
import { FormInput } from "@Components/Form";
import { useStore } from "@/Stores/requiredSettings";
import { useForm } from "@/form";
import { useI18n } from "vue-i18n";
import FormBase from "./FormBase.vue";
import { h } from "vue";

const props = defineProps({
    settings: Object,
});

const { t: __ } = useI18n();
const store = useStore();

const HaloScanIcon = h("div", [
    h(
        "span",
        {
            class: "inline-flex items-center pointer-events-none text-[#05e005] text-[40px]",
        },
        "〉"
    ),
]);

const form = useForm({
    api_key: props.settings?.api_key,
});

const submit = () => {
    if (form.processing) return;
    form.post("settings_api_update_haloscan").then(() => {
        store.refresh();
    });
};
</script>

<template>
    <FormBase @submit="submit" :form="form" :icon="HaloScanIcon" optional>
        <template #title>
            {{ __("HaloScan") }}
        </template>
        <template #description>
            <span class="block"
                >{{ __("Ajoutez l'outil de recherche HaloScan et visualisez la fréquence à laquelle les utilisateurs recherchent certains termes.") }}
            </span>
        </template>
        <template #form>
            <FormInput v-model="form.api_key" :label="__('Clé API')" :errors="form.errors.get('api_key')" sensitive>
                <template #hint>
                    <a href="https://tool.haloscan.com/user/api" target="_blank" class="font-bold text-gray-900 dark:text-white hover:underline">{{
                        __("Obtenir la clé API")
                    }}</a>
                </template>
            </FormInput>
        </template>
    </FormBase>
</template>
